import { render, staticRenderFns } from "./PlpListViewContainer.vue?vue&type=template&id=58a3ac0e&"
import script from "./PlpListViewContainer.vue?vue&type=script&lang=js&"
export * from "./PlpListViewContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports